import { render, staticRenderFns } from "./ProjectActions.vue?vue&type=template&id=3a706b73&scoped=true"
import script from "./ProjectActions.vue?vue&type=script&lang=js"
export * from "./ProjectActions.vue?vue&type=script&lang=js"
import style0 from "./ProjectActions.vue?vue&type=style&index=0&id=3a706b73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a706b73",
  null
  
)

export default component.exports